import React, { useEffect, useState } from 'react';
import { Calendar, MapPin, Sparkles, Trophy, Flame } from 'lucide-react';
import { finaleInfo as finaleMock } from '../data/mock';
import { api } from '../api/client';

const DEFAULT_BG = 'https://images.unsplash.com/photo-1600077063877-22118d6290eb?w=1600&q=80';

export default function FinaleBanner() {
  const [data, setData] = useState({
    label: 'Serata della Finale',
    title_part1: 'Domenica',
    title_part2: '31 Maggio 2026',
    stadio: finaleMock.stadio,
    indirizzo: finaleMock.indirizzo,
    bg_image: '',
    programma_title: 'Programma Serata Conclusiva',
    programma: finaleMock.programma,
  });

  useEffect(() => {
    let alive = true;
    api.getFinale().then((d) => {
      if (!alive || !d) return;
      setData((prev) => ({
        label: d.label || prev.label,
        title_part1: d.title_part1 || prev.title_part1,
        title_part2: d.title_part2 || prev.title_part2,
        stadio: d.stadio || prev.stadio,
        indirizzo: d.indirizzo || prev.indirizzo,
        bg_image: d.bg_image || '',
        programma_title: d.programma_title || prev.programma_title,
        programma: (Array.isArray(d.programma) && d.programma.length > 0) ? d.programma : prev.programma,
      }));
    }).catch(() => { /* fallback su mock */ });
    return () => { alive = false; };
  }, []);

  const bg = data.bg_image || DEFAULT_BG;

  return (
    <section className="py-20 relative overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img src={bg} alt="stadio" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-br from-navy-dark/95 via-navy/90 to-navy-dark/95"></div>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-4 lg:px-8">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 bg-pink-brand/25 border border-pink-brand rounded-full px-5 py-2 mb-5">
            <Sparkles size={16} className="text-pink-brand" />
            <span className="text-white font-bold uppercase text-xs tracking-widest">{data.label}</span>
          </div>

          <h2 className="font-display text-4xl md:text-6xl font-bold text-white uppercase mb-4">
            {data.title_part1} <span className="text-pink-brand">{data.title_part2}</span>
          </h2>

          <div className="flex items-center justify-center gap-2 text-white/80 text-lg mb-2">
            <MapPin size={20} className="text-pink-brand" />
            <span className="font-semibold">{data.stadio}</span>
          </div>
          {data.indirizzo && <p className="text-white/60 text-sm">{data.indirizzo}</p>}
        </div>

        {data.programma && data.programma.length > 0 && (
          <div className="max-w-3xl mx-auto glass-card overflow-hidden">
            <div className="bg-pink-brand px-5 py-3">
              <h3 className="text-white font-bold uppercase tracking-wider text-sm flex items-center gap-2">
                <Calendar size={16} /> {data.programma_title}
              </h3>
            </div>
            <div className="divide-y divide-white/10">
              {data.programma.map((p, i) => {
                const ev = String(p.evento || '').toLowerCase();
                const isFinal = ev.startsWith('finale');
                const isFuochi = ev.includes('piromusical') || ev.includes('fuoch');
                const Icon = p.icon === 'Flame' ? Flame : p.icon === 'Trophy' ? Trophy : (isFuochi ? Flame : isFinal ? Trophy : Sparkles);
                return (
                  <div key={i} className="p-3 sm:p-4 flex items-start gap-3 sm:gap-4 hover:bg-white/5 transition-colors">
                    <div className="bg-navy-dark border border-pink-brand/40 rounded-lg px-2 sm:px-3 py-1.5 sm:py-2 text-pink-brand font-bold text-xs sm:text-sm flex-shrink-0 min-w-[60px] sm:min-w-[70px] text-center">
                      {p.ora}
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-start gap-2">
                        <Icon size={16} className="text-pink-brand mt-1 flex-shrink-0" />
                        <span className="text-white font-semibold leading-snug text-sm sm:text-base break-words">{p.evento}</span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
